import moment from 'moment';

export default function addBusinessDays(days) {
  const currentDate = moment();
  let count = 0;

  while (count < days) {
    currentDate.add(1, 'days');
    if (currentDate.isoWeekday() !== 6 && currentDate.isoWeekday() !== 7) {
      count++;
    }
  }

  return currentDate;
}

const threeBusinessDaysFromNow = addBusinessDays(3);
